import React from "react";
import Dispositivos from "./components/Dispositivos";
import SolicitationTable from "./components/Solicitações";
import AprendizadoTable from "./components/Aprendizado";

export default function DispositivosPage() {

  return (
    <div className="flex mt-3 w-full flex-col gap-5">
      <div>
        <Dispositivos />
      </div>

      <div className="grid grid-cols-1 gap-5 lg:grid-cols-2">
        <div>
          <SolicitationTable />
        </div>

        <div>
          <AprendizadoTable />
        </div>
      </div>
    </div>
  );
}

